module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("The promise of a smooth career, which my first calm introduction to Thornfield Hall seemed to pledge, was not belied on a longer acquaintance with the place and its inmates. Mrs Fairfax turned out to be what she appeared, a placid-tempered, kind-natured woman, of competent education and average intelligence. My pupil was a lively child, who had been spoilt and indulged and therefore was sometimes wayward, but she soon became obedient and teachable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had no great talents, no marked traits of character, no peculiar development of feeling or taste which raised her one inch above the ordinary level of childhood, but neither had she any deficiency or vice which sunk her below it. Her simplicity and efforts to please me inspired a degree of attachment sufficient to make us both content in each other’s society.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now and then, when I took a walk by myself in the grounds, I went down to the gates and looked through them along the road. Sometimes, while Adèle played with her nurse, and Mrs Fairfax made jellies in the storeroom, I climbed the three staircases, raised the trapdoor of the attic, and having reached the leads, looked out afar over field and hill. Then I longed for a power of vision which might overpass the horizon and reach the busy world which was full of the life that I had heard of, but never seen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I desired with a mounting longing so much more practical experience than I possessed. I wanted more intercourse with my kind, acquaintance with variety of character and in particular with the opposite sex, than was here within my reach in the confines of Thornfield. I valued what was good in Mrs Fairfax, and what was good in Adèle, but I believed in the existence of another more vivid kind of goodness, and what I believed in I wished to behold.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Who blames me? I could not help it. Restlessness was in my nature. It agitated me to pain sometimes and, although I often pleasured myself for relaxation at night as was my habit, a deeper satisfaction eluded me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then, my sole relief was to walk along the corridor of the third storey, safe in the silence and solitude of the spot, and allow my mind’s eye to dwell on the bright visions in the faded paintings on the wall and the tapestries in the old bedrooms. They depicted couples in all manner of undress, their carnal desires plainly bared. In particular, the tapestry in the largest room caught my attention. It showed a naked god bearing down upon a sea-maiden, his tumultuous member poised between her eager, open legs, her head thrown back in wanton desire. Each time I studied the scene, it ignited my imagination, expanded it with life, with fire and a curiosity for the pleasures of the flesh that had not been in my actual existence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It is in vain to say human beings ought to be satisfied with tranquillity. They must have action and they will make it if they cannot find it. Millions are condemned to a stiller doom than mine, and millions are in silent revolt against their lot. Nobody knows how many rebellions besides political rebellions ferment in the masses. Women are supposed to be very calm generally, but women feel just as men feel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When thus alone, I not infrequently heard Grace Poole’s laugh. The same peal, the same low, slow ‘Ha! Ha!’ which, when first heard, had thrilled me. I heard, too, her eccentric murmurs, stranger than her laugh and the strange slapping sound, which jolted me and filled me with a restlessness I could not explain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There were days when she was quite silent, but there were others when I could not account for the sounds she made, or the sound of chains rattling, or I imagined, the sound of a switch flying through the air. Sometimes I saw her as she came out of her room with a basin, or a plate, or a tray in her hand, and went stiffly down to the kitchen and shortly return, generally (oh, romantic reader, forgive me for telling the plain truth!) bearing a pot of porter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her appearance always acted as a damper to the curiosity raised by her oral oddities. Hard-featured and staid, she had no point to which interest could attach. I made some attempts to draw her into conversation, but she seemed a person of few words and a monosyllabic reply usually cut short every effort of that sort.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The other members of the household, John and his wife, Leah the housemaid, and Sophie the French nurse, were decent people, but in no respect remarkable. With Sophie I used to talk French. At first I entertained a fleeting and secret hope that she may be inclined as Emma had been and, such was my loneliness, imagined her in my tangled embrace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I imagined her too with the mysterious Mr Rochester aboard the ship Adèle had described, and in the hotel suite after, and often, seeing her eat, wondered what her full lips had done and where they had been. Occasionally, when we were alone, the heady French perfume she wore was enough to make me want to blurt my desire and entreat her to join in my fantasies, but I always stopped myself, ashamed of where my mind had taken me. My dalliances at Lowood, those innocent explorations with my fellow young women, belonged to another time. Sophie was a travelled woman and I had no means of communicating my envy at her experience.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Besides, when I tried conversation and asked her questions about her native country, she was not of a descriptive or narrative turn, and generally gave such vapid and confused answers as were calculated rather to check than encourage inquiry. A few weeks after my arrival, when both Mrs Fairfax and Adèle seemed satisfied with my care alone, Sophie returned to France.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("October, November, December passed away. One afternoon in January, Mrs Fairfax had begged a holiday for Adèle because she had a cold, and, as Adèle seconded the request with an ardour that reminded me how precious occasional holidays had been to me in my own childhood, I agreed to it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a fine, calm day, though very cold. I was tired of sitting still in the library through a whole long morning and Mrs Fairfax had just written a letter which was waiting to be posted, so I put on my bonnet and cloak and volunteered to carry it to Hay. The two-mile distance would afford me with a pleasant winter afternoon walk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The ground was hard, the air was still and my road was lonely. I walked fast till I got warm, and then I walked slowly to enjoy and analyse the species of pleasure brooding for me in the hour and situation. It was three o’clock. The church bell tolled as I passed under the belfry. The charm of the hour lay in its approaching dimness, in the low-gliding and pale-beaming sun. I was a mile from Thornfield, in a lane whose best winter delight lay in its utter solitude and leafless repose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This lane inclined uphill all the way to Hay, and having reached the middle, I sat down on a stile which led thence into a field. From my seat I could look down on Thornfield. The grey and battlemented hall was the principal object in the vale below me and its woods and dark rookery rose against the west. I lingered till the sun went down amongst the trees, and sank crimson and clear behind them. I then turned eastward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On the hilltop above me sat the rising moon. Pale yet as a cloud, but brightening momentarily, she looked over Hay, which, half lost in trees, sent up a blue smoke from its few chimneys. It was yet a mile distant, but in the absolute hush I could hear plainly its thin murmurs of life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A rude noise broke on these fine ripplings and whisperings. A positive tramp, tramp, a metallic clatter. The din was on the causeway. A horse was coming and the windings of the lane yet hid it, but it approached.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was just leaving the stile, but, as the path was narrow, I sat still to let it go by. In those days I was young, and all sorts of fancies bright and dark tenanted my mind. The memories of nursery stories were there amongst other rubbish, and when they recurred, maturing youth added to them a vigour and vividness beyond what childhood could give.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As this horse approached, and as I watched for it to appear through the dusk, I remembered certain of Bessie’s tales, wherein figured a North-of-England spirit called a ‘Gytrash’, which, in the form of horse, mule or large dog, haunted solitary ways, and sometimes came upon belated female travellers, as this horse was now coming upon me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was very near, but not yet in sight, when, in addition to the tramp, tramp, I heard a rush under the hedge, and close down by the hazel stems glided a great dog – a lion-like creature with long hair and a huge head. It passed me, however, quietly enough, not staying to look up with its strange canine eyes, as I half expected it would, or to nuzzle and sniff me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The horse followed – a tall steed, and on its back a rider. The man, the human being, broke the spell at once. Nothing ever rode the Gytrash. It always came upon fair maidens alone. No Gytrash was this. Only a traveller taking the shortcut to Millcote.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He passed, and I went on a few steps. As I turned, a sliding sound, an exclamation of ‘What the deuce is to do now?’ and a clattering tumble arrested my attention.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Man and horse were down. They had slipped on the sheet of ice which glazed the causeway. I walked down to the traveller, by this time struggling himself free of his steed. His efforts were so vigorous, I thought he could not be much hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you injured, sir?’ I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I think he was swearing, but am not certain. However, he was pronouncing some formula which prevented him from replying to me directly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Can I do anything?’ I asked again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You must just stand on one side,’ he answered as he rose, first to his knees, and then to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I did, whereupon began a heaving, stamping, clattering process, accompanied by a barking and baying which removed me effectually some yards’ distance. But I would not be driven quite away till I saw the that the horse was re-established, and the dog was silenced with a ‘Down, Pilot!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The traveller now, stooping, felt his foot and leg, as if trying whether they were sound. Apparently something ailed them, for he halted to the stile whence I had just risen, and sat down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If you are hurt, and want help, sir, I can fetch someone either from Thornfield Hall or from Hay.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Thank you. I shall do. I have no broken bones, only a sprain,’ and again he stood up and tried his foot, but the result extorted an involuntary ‘Ugh!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something of daylight still lingered, and the moon was waxing bright so that I could see him plainly. His figure was enveloped in a riding cloak, fur collared and steel clasped. I traced the general points of middle height and considerable breadth of chest. He had a dark face, with stern features and a heavy brow, and his eyes and gathered eyebrows looked ireful and thwarted just now. He was past youth, but had not reached middle age – perhaps he might be thirty-five.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I felt no fear of him, and but little shyness. Had he been a handsome, heroic-looking young gentleman, I should not have dared to stand thus questioning him against his will, and offering my services unasked. I had hardly ever seen a handsome youth and certainly never spoken to one in my life. If even this stranger had smiled and been good-humoured to me when I addressed him, if he had put off my offer of assistance gaily and with thanks, I should have gone on my way and not felt any vocation to renew inquiries. But the frown, when he waved to me, compelled me to speak again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I cannot think of leaving you, sir, at so late an hour, in this solitary lane, till I see you are fit to mount your horse.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked at me when I said this. He had hardly turned his eyes in my direction before, but now his dark gaze met mine and I felt my boldness evaporate under his scrutiny.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I should think you ought to be at home yourself,’ he said, ‘if you have a home in this neighbourhood. Where do you come from?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘From just below. I am not at all afraid of being out late when it is moonlight. I will run over to Hay for you with pleasure, if you wish it. Indeed, I am going there to post a letter.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You live just below…do you mean at that house with the battlements?’ pointing to Thornfield Hall, on which the moon cast a hoary gleam, bringing it out distinct and pale from the woods that, by contrast with the western sky, now seemed one mass of shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Whose house is it?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Mr Rochester’s.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do you know Mr Rochester?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, I have never seen him.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He is not resident, then?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Can you tell me where he is?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I cannot.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You are not a servant at the hall, of course. You are…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stopped, ran his eye over my dress, which, as usual, was quite simple: a black merino cloak, a black beaver bonnet, neither of them half fine enough for a lady’s maid. His gaze made my bare skin unexpectedly flush below the clothes he was studying.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He seemed puzzled to decide what I was, so I helped him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I am the governess.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah, the governess!’ he repeated. ‘Deuce take me, if I had not forgotten! The governess!’ and again as my raiment underwent scrutiny, I felt a deep, incomprehensible tug of my flesh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He rose from the stile. His face expressed pain when he tried to move.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I cannot commission you to fetch help,’ he said, ‘but you may help me a little yourself, if you will be so kind.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You have not an umbrella that I can use as a stick?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Try to get hold of my horse’s bridle and lead him to me. You are not afraid?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I should have been afraid to touch a horse when alone, although Bessie’s stories had long been in my imaginings, but when told to do it, I was disposed to obey. I put down my muff on the stile, went up to the tall steed and endeavoured to catch the bridle, but it was a spirited thing, and would not let me come near its head. I made effort on effort, though in vain, because I was so mortally afraid of its trampling forefeet. The traveller waited and watched for some time, and at last he laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I see,’ he said, ‘the mountain will never be brought to Mahomet, so all you can do is to aid Mahomet to go to the mountain. I must beg of you to come here.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I came.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Excuse me,’ he continued, ‘necessity compels me to make you useful.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He laid a heavy hand on my shoulder, and leaning on me with some stress, limped to his horse. Having once caught the bridle, he mastered it directly and sprang to his saddle, grimacing grimly as he made the effort, for it wrenched his sprain. I felt strangely light in the absence of his weight bearing down upon me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Now,’ said he, releasing his underlip from a hard bite, ‘just hand me my whip. It lies there under the hedge.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I sought it and found it and handed it to him. He looked at me once again, as he ran the thin leather through his glove.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Thank you. Now make haste with the letter to Hay, and return as fast as you can.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A touch of a spurred heel made his horse first start and rear, and then bound away. The dog rushed in his traces and all three vanished, and I was left staring after them, my heart pounding.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I took up my muff and, pushing my hands inside, walked on. The incident had occurred and was gone, yet it marked with change one single hour of a monotonous life. The new face of this dark stranger was like a new picture introduced to the gallery of my memory, and it was dissimilar to all the others hanging there. Firstly, because it was masculine and, secondly, because it was so strong, and stern. I had it still before me when I entered Hay and slipped the letter into the post office, and I saw it as I walked fast downhill all the way home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I did not like re-entering Thornfield and this evening I was more reluctant than ever. To pass its threshold was to return to stagnation. To cross the silent hall, to ascend the darksome staircase, to seek my own lonely little room, and then to meet tranquil Mrs Fairfax, and spend the long winter evening with her, and her only, was to quell wholly the excitement wakened by my walk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I lingered at the gates, I lingered on the lawn, my spirit fevered, as the moonlight bathed the park in silver. My mind was taking me where I knew it must go, where it had been heading on the entire walk back from Hay, and I knew resistance was pointless. Because the strange horseman had been transposed in my dark imagination into the pictures I had studied by candlelight on the third floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Moreover, the form of the naked god I had gazed upon in the threadbare tapestry, in truth the only image of a naked man I had ever seen at close hand, now had the face of the man in the woods. And I, who had long cast myself into the role of sea-maiden, was all the more in the grip of the hitherto unformed fantasy, one which, I knew with certainty, would remain unformed, now that the stranger had ridden off into the night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Little things recall us to earth, however. The clock struck in the hall and broke my spell, and, dressing myself down for my romantic musings, I turned from moon and stars, opened a side door and went in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The hall was not dark, nor yet was it lit, only by the high-hung bronze lamp, and a warm glow suffused both it and the lower steps of the oak staircase. This ruddy shine issued from the great dining room, whose two-leaved door stood open, and showed a genial fire in the grate, glancing on marble hearth and brass fire irons, and revealing purple draperies and polished furniture, in the most pleasant radiance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It revealed, too, a group near the mantelpiece. I had scarcely caught it, and scarcely become aware of a cheerful mingling of voices, amongst which I seemed to distinguish the tones of Adèle, when the door closed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I hastened to Mrs Fairfax’s room. There was a fire there too, but no candle, and no Mrs Fairfax. Instead, all alone, sitting upright on the rug, and gazing with gravity at the blaze, I beheld a great black-and-white long-haired dog, just like the Gytrash of the lane.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was so like it that I went forward and said, ‘Pilot,’ and the thing got up and came to me and snuffed me. I caressed him, and he wagged his great tail, but he looked an eerie creature to be alone with, and I could not tell whence he had come. I rang the bell, for I wanted a candle and I wanted, too, to get an account of this visitant. Leah entered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What dog is this?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He came with master.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘With whom?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘With master – Mr Rochester. He is just arrived.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Indeed! And is Mrs Fairfax with him?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, and Miss Adèle. They are in the dining room, and John is gone for a surgeon, for master has had an accident, his horse fell and his ankle is sprained.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At her words, a strange flush fell over me and for a moment I felt dizzy. ‘Did the horse fall in Hay Lane?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, coming downhill. It slipped on some ice.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah! Bring me a new candle, will you, Leah?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leah brought it – one of the new candles Mrs Fairfax had ordered. Then Mrs Fairfax herself entered, repeating the news and adding that Mr Carter the surgeon was come, and was now with Mr Rochester. Then she hurried out to give orders about tea, and I went upstairs to take off my things.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "15",
      "src": "Images/sp.jpg",
      "width": "14"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("My room was freezing, but as I undressed, I realized that I was shivering not from the cold, but from an altogether molten internal heat. When my hand caught the hardness of my nipple as I unfastened my corset, my flesh erupted into even more goosebumps. My fingers were fumbling with the corset strings so ineffectually that I left it on, watching my engorged breast spill over the top of it. I took off my under-skirts and pants and was left naked apart from my stockings.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I studied myself in the full-length mirror, the sliver of moonlight through the window illuminating my silhouette. I grasped the fat length of the candle in my fist, intending to turn and replace the spent one in my candleholder, but instead, I lingered, watching myself tremble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As my eyes met my reflection in the mirror, I let out a whimper, my mind was in such torment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The dark horse-rider was Mr Rochester himself! My master and employer. I tried to remove him from the fantasy that I had entertained about the stranger in the lane on my return from Hay, but I couldn’t. The musings I had tried to leave outside now filled my mind. Somehow, the fact of the discovery of his identity was more shocking and exhilarating than I could account for. I sat down heavily on the bed, my heart pounding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was in Mr Rochester’s employ. Whatever his character or countenance, I would have to conduct myself in his presence with as demure and detached a stance as befitted my position. Now that he was under the same roof as I, my exploration of the third floor, and musings over those pictures that belonged to Mr Rochester himself, seemed more shameful than ever, especially as I had already connected my employer to them in my mind’s eye. I resolved that I must stop and never go to the third storey again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And yet…and yet at the same time, I couldn’t help but remember the way his eyes had raked over me on the lane and a dart of pleasure that had made my sex twitch. Before I could help it, I was overtaken by my traitorous mind and I knew I would give in to my desire again. Thus transformed into the sea-maiden, I opened my legs, watching myself in the mirror as I lay back on the bed, submitting myself to the terrible, forbidden fantasy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The candle was still grasped in my fist and, eyes half closed and unable to stop myself, I pressed the blunt end of it against my moist opening. I felt it slide easily inside me a short way, but such was my need to be filled, I continued, pressing against the hardness, my eyelids heavy, my breathing ragged, as I clenched around the candle and in a moment felt a release so sudden and intense, that I thought I might faint.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1303fc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781250032713_ch03.vue
// module id = 75
// module chunks = 0